import * as angular from "angular";
import {IController} from "angular";
import {PoliciesAlertsService} from "../../services/policies-alerts.service";
import {PoliciesRequestsService} from "../../services/policies-requests.service";

export class PolicyTokenViewComponent implements IController {

  extendedPolicy: any;
  orgId: any;
  siteId: any;

  public otpTokenTtlMillis: number;
  public tokenTtlMillis: number;
  public loading: boolean;

  /* @ngInject */
  constructor(private $log, private policiesRequestsService: PoliciesRequestsService, private policiesAlertsService: PoliciesAlertsService, private splitService) {
  }

  $onInit() {
    this.otpTokenTtlMillis = this.extendedPolicy.policy.tokenPolicy.otpTokenTtlMillis;
    this.tokenTtlMillis = this.extendedPolicy.policy.tokenPolicy.tokenTtlMillis;
    this.loading = false;
  }

  save(event) {
    this.loading = true;

    const tokenPolicy = {
      otpTokenTtlMillis: this.otpTokenTtlMillis,
      tokenTtlMillis: this.tokenTtlMillis
    };

    this.policiesRequestsService.updateTokenPolicy(this.extendedPolicy.policy.id, tokenPolicy, this.orgId, this.siteId)
      .then((updatedTokenPolicy) => {
        this.extendedPolicy.policy.tokenPolicy = updatedTokenPolicy;
        this.policiesAlertsService.updatePasswordPolicySuccess();
      })
      .catch((error) => {
        this.policiesAlertsService.updatePasswordPolicyError();
        this.$log.error('Failed to update password policy', error);
      })
      .finally(() => {
        this.loading = false;
      });
  }

}

angular
  .module('bringoz.admin.policies')
  .component('policyTokenView', {
    bindings: {
      extendedPolicy: '<',
      orgId: '<?',
      siteId: '<?'
    },
    template: require('./policy-token-view.html').default,
    controller: PolicyTokenViewComponent
  });
